export default __webpack_public_path__ + "1c2df1d.png";